import { type SubmitFunction } from '@remix-run/react'

import cloneDeep from 'lodash/cloneDeep.js'
import {
	type QuestionText,
	type BackendActions,
	type JSONState,
} from '#types/form/wizard.ts'
import { extractFormValues } from './extractFormValues.ts'

interface HandleSubmitFormParams {
	submit: SubmitFunction
	fieldKey: string
	id: string
	actionRoute: string
	CSRFToken: string
	backendAction: BackendActions
	questionText: QuestionText[]
	wizardMessages: any
	currentFormContext: { [key: string]: string }
	entireGlobalState: any
}

const cleanStateForSerialization = (state: any) => {
	const cleanedState = cloneDeep(state)
	cleanedState.editableParents = []

	delete cleanedState.dispatch

	return cleanedState
}

export function handleSubmitForm<T>({
	fieldKey,
	questionText,
	currentFormContext,
	id,
	actionRoute,
	backendAction,
	CSRFToken,
	entireGlobalState,
	wizardMessages,
	submit,
}: HandleSubmitFormParams) {
	const formData = new FormData()
	const newDataToSend = {
		...entireGlobalState.formState,
		...currentFormContext,
	}

	const globalFormState = {
		...entireGlobalState,
		editableParents: [],
		formState: newDataToSend,
	} as unknown as JSONState<T>

	Object.keys(newDataToSend).forEach(key => {
		const value = newDataToSend[key]
		formData.append(
			`${key}`,
			typeof value === 'object' ? JSON.stringify(value) : value,
		)
	})

	let formValues: any

	if (questionText) {
		formValues = extractFormValues({
			newDataToSend,
			fieldKey,
			typeOfQuestion: 'regular',
			questionText,
		}) as any
	}

	const cleanedGlobalState = cleanStateForSerialization(globalFormState)

	formData.append('id', id)
	formData.append('csrf', CSRFToken)
	formData.append('backendAction', backendAction)
	formData.append('questionText', JSON.stringify(questionText, null, 2))
	formData.append('fieldKey', fieldKey)
	formData.append(`currentQuestionValues`, JSON.stringify(formValues, null, 2))

	formData.append(
		'globalState',
		JSON.stringify({ ...cleanedGlobalState }, null, 2),
	)
	formData.append('wizardMessages', JSON.stringify(wizardMessages, null, 2))

	submit(formData, { method: 'post', action: `${actionRoute}` })
}
